import SalesSearchDashboard from '@/components/buscador/SalesSearchDashboard'

export default function BuscadorPage() {
  return <SalesSearchDashboard />
}
